import React, { useContext, useEffect, useState } from 'react';

import { ServiceResponse } from '../../../app/services/shared/interfaces';
import { AppContext } from '../../../contexts/AppContext';
import { toast } from 'react-toastify';
import useReactConfirmAlert from '../../../hooks/useReactConfirmAlert';
import LazyLoading from '../../../components/LazyLoading';
import ButtonCancelForm from '../../../components/buttons/ButtonCancelForm';
import ButtonSaveForm from '../../../components/buttons/ButtonSaveForm';
import { Currency } from '../../../app/models/Currency';
import ForeignExchangeForm from './forms/ForeignExchangeForm';
import useForeingExchangeService from '../../../app/services/hooks/useForeignExchangeService';
import { ForeignExchanges, defaultForeignExchangeDataForm } from '../../../app/models/ForeignExchange';

interface Props {
    foreignExchangeId: number;
    onSaved?: () => void;
    onCancel?: () => void;
    onError?: () => void;
}

const ForeignExchangeEdit = ({ foreignExchangeId, onSaved, onCancel, onError }: Props) => {
    const { showLoading, hideLoading, changeAnimation } = useContext(AppContext);

    const [currencies, setCurrencies] = useState<Currency[]>([]);
    const [foreignExchange, setForeignExchange] = useState<ForeignExchanges>(defaultForeignExchangeDataForm);
    const [errorFields, setErrorFields] = useState<any>();
    const [errorGetData, setErrorGetData] = useState('');

    const { 
        fetchingEditForeignExchange,
        fetchingUpdateForeignExchange,
        editForeignExchange, 
        updateForeignExchange
    } = useForeingExchangeService();

    useEffect(() => {
        edit();
    }, []);

    const edit = () => {
        if (showLoading) showLoading('loading', 'Cargando tipo de cambio...');
        editForeignExchange(foreignExchangeId, {
            onSuccess: (response: ServiceResponse) => {
                setForeignExchange(response.data.foreign_exchange);
                setCurrencies(response.data.currencies);
                if (hideLoading) hideLoading();
            },
            onError: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();
                toast.error(response.message);
                setErrorGetData(response.message);
                if (onError) onError();
            }
        });
    };

    const update = () => {
        if (showLoading) showLoading('loading', 'Actualizando tipo de cambio...');
        updateForeignExchange(foreignExchangeId, foreignExchange, {
            onSuccess: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();

                useReactConfirmAlert().successAlert({
                    title: 'Éxito',
                    message: response.message
                });
                toast.success(response.message, {
                    autoClose: 2500
                });
                if (onSaved) onSaved();
            },
            onError: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();

                useReactConfirmAlert().errorAlert({
                    title: 'Error',
                    message: response.message
                });
            },
            onFieldError: (errorFields: ServiceResponse) => {
                if (hideLoading) hideLoading();
                setErrorFields(errorFields.data);
            }
        });
    };

    const cancel = () => {
        if (onCancel) onCancel();
    };

    if (errorGetData !== '') {
        return <div>{errorGetData}</div>;
    }

    return fetchingEditForeignExchange ? (
        <LazyLoading height={300} />
    ) : (
        <>
            <div className="row">
                <div className="col-12">
                    <ForeignExchangeForm
                        currencies={currencies}
                        foreignExchangesDataForm={foreignExchange}
                        setforeignExchangesDataForm={setForeignExchange}
                        errorFields={errorFields}
                        manually={true}
                    />
                </div>
            </div>
            <hr />
            <div className="row justify-content-end">
                <div className="col-auto">
                    <ButtonCancelForm callbackCancel={cancel} locked={fetchingUpdateForeignExchange} />
                </div>
                <div className="col-auto">
                    <ButtonSaveForm callbackSave={update} locked={fetchingUpdateForeignExchange} />
                </div>
            </div>
        </>
    );
};

export default ForeignExchangeEdit;
